<template>

    <div class="container">

        <app-head title="Addresses" />

        <back :href="route('admin.customers.index')" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Addresses') }}: {{ customer.name }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.customers.addresses.create', customer)">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="addresses.meta" />
        </div>

        <div class="card">
            <data-table :items="addresses.data"
                        :links="addresses.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="address in addresses.data" :key="address.id">
                    <td>
                        {{ address.id }}
                    </td>
                    <td>
                        <inertia-link class="stretched-link" :href="route('admin.addresses.edit', address)">
                            {{ address.company || '-' }}
                        </inertia-link>
                    </td>
                    <td>
                        {{ address.last_name }}, {{ address.first_name }}
                    </td>
                    <td>
                        {{ address.zip_code || '-' }}
                    </td>
                    <td>
                        {{ address.city || '-' }}
                    </td>
                    <td>
                        {{ address.street }}
                        {{ address.house_number }}
                    </td>
                    <td>
                        {{ address.created_at | localizeDateTime }}
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';

    import Boolean from '@/shared/Admin/Boolean';

    import Results from '@/shared/Admin/Results';

    export default {
        props: [
            'filters',
            'customer',
            'addresses',
        ],
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
            Boolean,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    company: {label: 'Company', sortable: 'company'},
                    name: {label: 'Name', sortable: 'last_name'},
                    zip_code: {label: 'Zip Code', sortable: 'zip_code'},
                    city: {label: 'City', sortable: 'city'},
                    street: {label: 'Street', sortable: 'street'},
                    created_at: {label: 'Created', sortable: 'created_at'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.customers.addresses.index', this.customer), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>